import { SalesLayout } from '@/features/sales/SalesLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sales')({
  staticData: { nav: 'sales' },
  component: SalesLayout,
});
